import CoachPhotos from './coach-photos'

export default CoachPhotos
